import { render, staticRenderFns } from "./TodayCalling.vue?vue&type=template&id=2e258bc4&scoped=true"
import script from "./TodayCalling.vue?vue&type=script&lang=js"
export * from "./TodayCalling.vue?vue&type=script&lang=js"
import style0 from "./TodayCalling.vue?vue&type=style&index=0&id=2e258bc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e258bc4",
  null
  
)

export default component.exports